import React, {useState} from "react";
import { Button, Column, Columns, Field, Modal, Section } from "@allxsmith/bestax-bulma";
import useInput from "../../hooks/useInput";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";

export default function MultipleEditModalWorkshop({
  open,
  setOpen,
  selected,
  saveSelected,
  trackingOptions,
  trackingObjects,
  nominalCodes,
  codeObjects
}) {

  const [invoiceNumber, invoiceNumberInput, setInvoiceNumber] = useInput({
    type: "text",
    label: "Workshop Invoice Number"
  });

  const [invoiceDate, invoiceDateInput] = useInput({
    type: "date",
    label: "Invoice Date"
  });

  const [trackingOption, setTrackingOption] = useState();
  const [nominalCode, setNominalCode] = useState();

  const onTrackingOptionChange = e => {
    setTrackingOption(trackingObjects[e.target.value]);
  }

  const onNominalCodeChange = e => {
    setNominalCode(codeObjects[e.target.value]);
  }

  const onSave = () => {
    saveSelected(invoiceNumber, null, trackingOption, nominalCode, null, null, invoiceDate).then(onClose);
  };

  const onClose = () => {
    setOpen(false);
    setInvoiceNumber("");
    setTrackingOption(undefined);
    setNominalCode(undefined);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal closeOnBlur active={open} onClose={onClose}>
      <Modal.Content className={"wider-modal"}>
        <Section style={{ backgroundColor: "white" }}>
          <Columns isMultiline>
            {invoiceNumberInput}
            {invoiceDateInput}
            <Column>
              <TrackingOptionsPicker
                name={"supplier_tracking_option"}
                label={"Tracking Option"}
                value={trackingOption}
                options={trackingOptions}
                blank={true}
                className={"not-small"}
                inlineEdit={false}
                editable={true}
                onChange={onTrackingOptionChange}
              />
            </Column>
            <Column>
              <NominalCodePicker
                name={"supplier_nominal_code"}
                label={"Nominal Code"}
                value={nominalCode}
                options={nominalCodes}
                blank={true}
                small={false}
                inlineEdit={false}
                editable={true}
                onChange={onNominalCodeChange}
              />
            </Column>
          </Columns>
          <Field>
            <p>You are editing {Object.keys(selected).length} work items</p>
          </Field>
          <Columns>
            <Column>
              <Button color="success" onClick={onSave}>
                Save
              </Button>
            </Column>
            <Column>
              <Button color="info" onClick={() => setOpen(false)}>
                Cancel
              </Button>
            </Column>
          </Columns>

        </Section>
      </Modal.Content>
    </Modal>
  );
}
